import React from "react";
import Container from 'react-bootstrap/Container';
import { Footer } from './headerFooter';
import "./custom.scss";

const TermsOfUse = () => {
  return (
    <div id="root">
      <main className='main-container'>
        <Container className='custom-container pt-3'>
            <h2>Όροι Χρήσης</h2>
            <p>Τελευταία ενημέρωση: 5 Ιουνίου 2025</p>

            <h3>1. Περιγραφή Υπηρεσίας</h3>
            <p>
              Η εφαρμογή <strong>teachers-app.com</strong> απευθύνεται σε{" "}
              <strong>αναπληρωτές και μόνιμους εκπαιδευτικούς όλων των ειδικοτήτων</strong> και
              παρέχει πληροφορίες, εργαλεία και λειτουργίες που βασίζονται σε{" "}
              <strong>δημόσια δεδομένα</strong> από την επίσημη ιστοσελίδα του{" "}
              <strong>Υπουργείου Παιδείας, Θρησκευμάτων και Αθλητισμού</strong> της Ελληνικής Δημοκρατίας (minedu.gov.gr).
            </p>

            <h3>2. Προέλευση και Χρήση Δεδομένων</h3>
            <p>
              Όλα τα δεδομένα που χρησιμοποιούνται στην εφαρμογή είναι{" "}
              <strong>δημόσια προσβάσιμα</strong> και προέρχονται από επίσημες ανακοινώσεις,
              πίνακες και έγγραφα του Υπουργείου Παιδείας. Η εφαρμογή{" "}
              <strong>δεν μεταβάλλει, αλλοιώνει ή αποκρύπτει</strong> τα δεδομένα αυτά, αλλά τα
              παρουσιάζει με τρόπο που διευκολύνει την κατανόηση και την πρόσβαση των χρηστών.
            </p>
            <p>
              Η χρήση των δεδομένων γίνεται{" "}
              <strong>κατά τρόπο συμβατό με τους όρους ανοικτών δεδομένων</strong> (Open Data)
              του ελληνικού δημοσίου, όπου αυτοί ισχύουν.
            </p>

            <h3>3. Περιορισμός Ευθύνης</h3>
            <p>
              Η ομάδα του <strong>teachers-app.com</strong> καταβάλλει κάθε δυνατή προσπάθεια
              για την παροχή ακριβούς και έγκυρης πληροφόρησης. Παρ' όλα αυτά:
            </p>
            <ul>
              <li>Δεν εγγυάται την πληρότητα, ακρίβεια ή επικαιρότητα των πληροφοριών.</li>
              <li>Δεν φέρει ευθύνη για τυχόν λάθη, παραλείψεις ή παρερμηνείες των δεδομένων.</li>
              <li>
                Οι χρήστες φέρουν την αποκλειστική ευθύνη για οποιαδήποτε απόφαση ή ενέργεια
                βασισμένη στις πληροφορίες που παρέχονται από την εφαρμογή.
              </li>
            </ul>
            <p>
              Για επίσημες αποφάσεις, οι χρήστες καλούνται να ανατρέχουν στην{" "}
              <strong>επίσημη ιστοσελίδα του Υπουργείου Παιδείας</strong>.
            </p>

            <h3>4. Πνευματικά Δικαιώματα</h3>
            <p>
              Το περιεχόμενο της εφαρμογής (π.χ. σχεδίαση, κώδικας, οργάνωση πληροφοριών), με
              εξαίρεση τα δημόσια δεδομένα, αποτελεί{" "}
              <strong>πνευματική ιδιοκτησία της ομάδας ανάπτυξης του teachers-app.com</strong>.
            </p>
            <p>
              Απαγορεύεται η αντιγραφή, αναπαραγωγή, τροποποίηση ή εμπορική εκμετάλλευση
              οποιουδήποτε μέρους της εφαρμογής χωρίς προηγούμενη γραπτή άδεια.
            </p>

            <h3>5. Αλλαγές στους Όρους</h3>
            <p>
              Οι παρόντες Όροι Χρήσης ενδέχεται να τροποποιούνται οποτεδήποτε, χωρίς
              προειδοποίηση. Οι χρήστες οφείλουν να ελέγχουν περιοδικά τους όρους για τυχόν
              αλλαγές.
            </p>
            <p>
              Η συνέχιση της χρήσης της εφαρμογής συνιστά αποδοχή των τροποποιημένων όρων.
            </p>

            <h3>6. Επικοινωνία</h3>
            <p>
              Για οποιαδήποτε ερώτηση, απορία ή αίτημα σχετικό με τους Όρους Χρήσης, μπορείτε
              να επικοινωνήσετε μαζί μας στο: <strong><a href="mailto:support@teachers-app.com">support@teachers-app.com</a></strong>
            </p>
        </Container>
      </main>
    <Footer />
    </div>
  );
};


export default TermsOfUse;
